import CompanyQueries from "./company/company.query";
import CompanyMutations from "./company/company.mutation";

const CompanyServices = {
  ...CompanyQueries,
  ...CompanyMutations,
};

export default CompanyServices;
